var map = {
	"./brick-cafe-interior.jpg": "8b11",
	"./cosmos1.jpg": "0856",
	"./hadjidraganovi2.jpg": "f833",
	"./karmare-interior.jpg": "dd52",
	"./made-in-home2.jpg": "7b08",
	"./moma-interior.jpg": "73ed",
	"./shtastliveca.jpg": "f3df",
	"./tenebris2.png": "d833"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3cc8";